export const MFAStatus = {
  VERIFIED: 'VERIFIED',
  REGISTERED: 'REGISTERED',
  UNREGISTERED: 'UNREGISTERED',
};
